import { Component, OnInit } from '@angular/core';
import { Offerte } from '../model/offerte';
import { OfferteServiceService } from '../service/offerte-service.service';
import { LeadserviceService } from '../service/leadservice.service';
import { ActivatedRoute } from '@angular/router';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-offertecentralihome',
  templateUrl: './offertecentralihome.component.html',
  styleUrls: ['./offertecentralihome.component.scss']
})
export class OffertecentralihomeComponent implements OnInit {
  ulrbase = "localhost:4200";
  private sub: any;
  lstOffertePunta: Array<Offerte>;
  constructor(private service: OfferteServiceService, private servicelead: LeadserviceService, private route: ActivatedRoute, private meta: Meta ) {

    // this.lstOffertePunta = this.service.getOffertePunta();
    this.lstOffertePunta=null;
    this.service.getOffertePunta().subscribe(data => this.lstOffertePunta=data);


    // this.meta.updateTag({ name: 'title', content: 'Fornituralternativa.com | Affidati ai nostri professionisti, il risparmio ti aspetta' });
    // this.meta.updateTag({ name:'description', content:'Sei stanco di essere un numero? Non Ti senti Valorizzato dai fornitori che gestiscono le tue Utenze? Fornituralternativa.com | Affidati ai nostri professionisti, il risparmio ti aspetta   '});
    // this.meta.updateTag({ name: 'keywords', content: 'Abolizione Mercato Tutelato , Mercato efwfwef libero' });


  }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/offertecentralihome/offertecentralihome.component.ts